import { Checkbox, CollectionIcon, useModeContext } from 'canoe';
import React from 'react';

import { TargetLocationsEnglishNames } from 'craft/types';

import { FieldContentSelector } from './FieldContentSelector';
import {
  CheckboxLabelToolbar,
  CollectionLocation,
  CollectionName,
  DynamicSettingsRow,
  FieldEditorContainer,
} from './StyledComponents';
import { FieldEditorPropsImpl } from './types';

export const FieldEditorToolbar = React.memo(
  ({
    isUsingCollectionField,
    onToggleCheckbox,
    targetLocation,
    usedCollection,
    errorMessage,
    onFieldSelection,
    selectedField,
    collectionEmbedLocations,
  }: FieldEditorPropsImpl) => {
    const { mode } = useModeContext();
    return (
      <FieldEditorContainer
        isPopover
        mode={mode}
        isActive={isUsingCollectionField}
        testId="collection-fields-wrapper"
      >
        <DynamicSettingsRow>
          <Checkbox
            data-cy="use-collection"
            scale="small"
            variant="orange"
            id={`${targetLocation}-checkbox-use-collection`}
            checked={isUsingCollectionField}
            onChange={onToggleCheckbox}
          >
            <CheckboxLabelToolbar
              htmlFor={`${targetLocation}-checkbox-use-collection`}
              element="label"
              mode={mode}
            >
              <CollectionLocation>
                Get {TargetLocationsEnglishNames[targetLocation]} from
              </CollectionLocation>
              &nbsp;
              <CollectionName>{usedCollection?.collectionName}</CollectionName>
              &nbsp;&nbsp;
              <CollectionIcon color="GlitterGray" size="s" />
            </CheckboxLabelToolbar>
          </Checkbox>
        </DynamicSettingsRow>
        {isUsingCollectionField && (
          <FieldContentSelector
            hasError={!!errorMessage}
            selectedField={selectedField?.fieldId ?? ''}
            availableFields={collectionEmbedLocations}
            onSelectField={(fieldId: string) =>
              usedCollection &&
              onFieldSelection({
                collectionId: usedCollection.id,
                targetLocation,
                fieldId,
              })
            }
          />
        )}
      </FieldEditorContainer>
    );
  },
);
